module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer m-t-md"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "n-m-t p-t-sm"
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row m-t-sm p-t-b-sm desc"
  }, [_c('div', {
    staticClass: "text-center m-b-xs"
  }, [_vm._v("Copyright © " + _vm._s(_vm.cr_text) + " " + _vm._s(_vm.global.name) + ". 当前版本 " + _vm._s(_vm.global.version))]), _vm._v(" "), _c('div', {
    staticClass: "text-center m-b-xs"
  }, [_vm._v(_vm._s(_vm.global.icp) + " 北京华宇互联科技有限公司版权所有")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row partners"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner"
  }, [_c('a', {
    attrs: {
      "href": "http://www.psych.cas.cn",
      "title": "中国科学院心理研究所",
      "alt": "中国科学院心理研究所",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/assets/images/psych2_03.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner"
  }, [_c('a', {
    attrs: {
      "href": "http://www.lechenggu.com",
      "title": "乐橙谷",
      "alt": "乐橙谷",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/assets/images/lechenggu-logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner"
  }, [_c('a', {
    attrs: {
      "href": "http://www.litsoft.com.cn",
      "title": "联和利泰",
      "alt": "联和利泰",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/assets/images/litsoft-logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3  m-b-sm text-center partner"
  }, [_c('a', {
    attrs: {
      "href": "https://www.lenovo.com.cn",
      "title": "联想集团",
      "alt": "联想集团",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/assets/images/lenovo-logo.jpg",
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c5a2492","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/footer.vue
// module id = 472
// module chunks = 1